import styled from 'styled-components'; 
export const FullScreen = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 300;
`;

export const WhiteBox = styled.div`
    border-radius: 15px 15px 0 0;
    width: 100%;
    height: calc(100vh * (353 / 812));
    padding: calc(100vw * (27 / 375)) calc(100vw * (20 / 375)) calc(100vw * (55 /375)) calc(100vw * (20 / 375));
    background: #fff;
`;

export const AllCheckBlock = styled.div`
    position: relative;
    width: 100%;
    padding: calc(100vw * (18 / 375)) 0;
    border: 1px solid #eaeaea;
    border-radius: calc(100vw * (5 / 375));
    color: #121212;
    font-wieght: bold;
    
`;

export const CheckBoxLabel = styled.label`
    position: relative;
    display: flex;
    padding-left: calc(100vw * (14 / 375));
    font-size: calc(100vw * (16 / 375));
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;

export const SmallCheckBoxLabel = styled(CheckBoxLabel)`
    font-size: calc(100vw * (12 / 375));
    margin-top: calc(100vh * (19 / 812));
`;

export const TermsAndPositionLink = styled.button`
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    text-decoration: underline;
    text-underline-position: under;
    color: #121212;
`;

export const SelectCheckBlock = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SignupCompleteBtn = styled.div`
    background: #ffcf19;
    margin-top: calc(100vh * (38 / 812));
    padding: calc(100vw * (19 / 375)) 0;
    color: #121212;
    text-align: center;
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
    line-height: calc(100vw * (26 / 375));
    border-radius: calc(100vw * (5 / 375));
`;

export const DisableSignupCompleteBtn = styled.div`
    background: #dbdbdb;
    margin-top: calc(100vh * (38 / 812));
    padding: calc(100vw * (19 / 375)) 0;
    color: #989898;
    text-align: center;
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
    line-height: calc(100vw * (26 / 375));
    border-radius: calc(100vw * (5 / 375));
`;
